import { createContext, useContext } from "react"

export const TileRefContext = createContext<Map<number, HTMLDivElement> | null>(null)

export function useTileRefMap(): Map<number, HTMLDivElement> | null {
  return useContext(TileRefContext)
}
